import {makeAdultsCounter, makeChildsCounter} from '../actions/utils'
import {isSameDate} from '../../../../utils/helper'
import {PRODUCT_TOUR} from '../../../../types/products'

export const updateSummary = (state) => {
  updatePrices(state)
  updatePersons(state)
  updateCounters(state)
}

const updatePrices = (state) => {
  let total = 0
  total += makePriceFlights(state)
  total += makePriceFlightDepartureInfo(state)
  total += makePriceHotels(state)
  total += makePriceServices(state)
  total += makePriceTrasferimenti(state)
  total += makePriceTour(state)
  total += makePriceSpese(state)
  state.summary.totalPrice = total
}

const makePriceFlights = (state) => {
  const { from, to } = state.flights
  if (!from) return 0
  return from.prezzoVendita > to.prezzoVendita ? from.prezzoVendita : to.prezzoVendita
}

const makePriceFlightDepartureInfo = (state) => {
  const { flightTransferService } = state.flightDepartureInfo
  return flightTransferService ? calcServicePrice(flightTransferService) : 0
}

const makePriceHotels = (state) => {
  let totale = 0
  state.hotels.list.forEach(item => {
    item.selected.forEach(hotel => {
      const roomsSelected = hotel.rooms.filter(room => room.selected)
      roomsSelected.forEach(room => {
        totale += room.price.venditaTotaleEuro
      })
    })
  })
  return totale
}

const makePriceServices = (state) => {
  let totale = 0
  state.services.selected.forEach(item => {
    totale += calcServicePrice(item)
  })
  return totale
}

const makePriceTrasferimenti = (state) => {
  let totale = 0
  const {andata, ritorno} = state.trasferimenti
  if (andata) {
    totale += calcServicePrice(andata)
  }
  if (ritorno) {
    totale += calcServicePrice(ritorno)
  }
  return totale
}

const calcServicePrice = (service) => {
  let totale = 0
  const groupsSelected = service.groups.filter(group => group.selected)
  groupsSelected.forEach(group => {
    if (group.selected) {
      const priceByDay = service.pricesByDay.find(price => isSameDate(price.day, group.dateSelected))
      if (priceByDay) {
        const priceByGroup = priceByDay.prices.find(item => item.group === group.id)
        totale += priceByGroup ? priceByGroup.venditaTotaleEuro : 0
      }
    }
  })
  return totale
}

const makePriceTour = (state) => {
  let totale = 0
  state.tour.detailResponses.forEach(group => {
    group.prices.forEach(item => {
      totale += item.selected ? item.price.venditaTotaleEuro : 0
    })
  })
  return totale
}

const makePriceSpese = (state) => {
  let totale = 0
  state.spese.forEach(list => {
    list.forEach(item => {
      totale += item.selected ? item.prezzo.venditaTotaleEuro * item.prezzo.quantita : 0
    })
  })
  return totale
}

const updatePersons = (state) => {
  state.summary.adults = makeAdultsCounter(state)
  state.summary.childs = makeChildsCounter(state)
  const persons = state.summary.adults + state.summary.childs
  state.summary.totalPricePerPerson = Math.round(state.summary.totalPrice / persons)
}

const updateCounters = (state) => {
  state.summary.nights = state.days.length - 1
  if (state.search.product === PRODUCT_TOUR && state.tour.anagrafica) {
    state.summary.nights = state.tour.anagrafica.element.nights
  }
  if (state.services.list.length > 0) {
    state.summary.services = state.services.selected.length
  } else {
    if (state.tour.services) {
      state.summary.flights = state.tour.services.length
    }
  }
  if (state.flights.from) {
    state.summary.flights = state.flights.from.voli.length + state.flights.to.voli.length
  } else {
    if (state.tour.flights) {
      state.summary.flights = state.tour.flights[0].voli.length
    }
  }
}



// WEBPACK FOOTER //
// ./src/front/store/modules/itinerario/actions/summary.js